





































import PageHeader from '@/components/PageHeader'
import PageFooter from '@/components/PageFooter'
import rootable from '@/mixins/rootable.coffee'
import ArticleTextSection from '@/components/ArticleTextSection'
import ArticleImage from '@/components/ArticleImage'
import ArticleVideo from '@/components/ArticleVideo'

export default {
    name: 'ArticlePage'

    mixins: [rootable]

    components:
        PageHeader: PageHeader
        PageFooter: PageFooter
        ArticleTextSection: ArticleTextSection
        ArticleImage: ArticleImage
        ArticleVideo: ArticleVideo

    computed:
        headerId: -> @$parent.fields.default_header.id 
        footerId: -> @$parent.fields.default_footer.id

    data: ->
        documentId: '' 
        fields: @defaultFields()

    methods:
        defaultFields: ->
            meta_title: [],
            meta_description: []
            content: []

        setContent: (document) ->
            @documentId = document.id
            fields =
                meta_title: document.data.meta_title
                meta_description: document.data.meta_description
                content: document.data.body
            $.extend @fields, fields

        getContent: (uid) ->
            @$prismic.client.getByUID('article', uid).then (document) =>
                #if not document then @$router.push '/not-found'
                @setContent document

    created: ->
        uid = @$route.params.uid
        @getContent uid
}
